<div style="padding-left: 10px; line-height: 25px;">
  <span> {{ params.loadingMessage }} </span>
</div>
